import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useAuth } from "../../../../../context/AuthContext";
import Swal from "sweetalert2";
import { API_BASE_URL } from "../../../../../Helpers/apiConfig";

export const AdminPackageCreateCorporate = () => {
    const { user } = useAuth();
    const { t } = useTranslation();

    const [msg, setMsg] = useState("");
    const [sections, setSections] = useState([]);
    const [loadingSections, setLoadingSections] = useState(true);
    const [form, setForm] = useState({
        packageName: "",
        packageDetail: "",
        packagePrice: "",
        studentLimit: "",
        howManyDays: "",
        sectionId: ""
    });

    useEffect(() => {
        const fetchSections = async () => {
            try {
                const headers = {
                    accept: "*/*",
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Credentials": "false",
                    Authorization: "Bearer " + user.token
                };

                const url = API_BASE_URL + "/admin/SectionManager/GetList";
                const res = await axios({
                    method: "GET",
                    url,
                    headers
                });

                if (res.status === 200 && res.data?.success) {
                    const activeSections = (res.data.data || []).filter(
                        (section) => section.isDeleted === false && section.isActive === true
                    );
                    setSections(activeSections);
                } else {
                    setMsg(res.data?.message || "Sectionlar alınamadı.");
                }
            } catch (err) {
                setMsg(err?.message || "Sectionlar alınamadı.");
            } finally {
                setLoadingSections(false);
            }
        };

        fetchSections();
    }, [user.token]);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setForm((prev) => ({ ...prev, [id]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const headers = {
                accept: "*/*",
                "Content-Type": "application/json",
                "Access-Control-Allow-Credentials": "false",
                Authorization: "Bearer " + user.token
            };

            const url = API_BASE_URL + "/admin/Package/Create";
            const res = await axios({
                method: "POST",
                url,
                data: {
                    packageName: form.packageName,
                    packageDetail: form.packageDetail,
                    packagePrice: Number(form.packagePrice),
                    studentLimit: Number(form.studentLimit),
                    howManyDays: Number(form.howManyDays),
                    sortNumber: Number(form.sectionId),
                    isItPrivate: false,
                    isInvidual: false,
                    isActive: true
                },
                headers
            });

            if (res.status === 200 && res.data?.success) {
                await Swal.fire({
                    title: "Başarılı!",
                    icon: "success",
                    confirmButtonText: "Tamam"
                });
                window.location.reload();
                return;
            }

            Swal.fire({
                title: "Hata!",
                icon: "error",
                confirmButtonText: "Tamam"
            });
            setMsg(res.data?.message || "Beklenmedik bir hata oluştu.");
        } catch (err) {
            setMsg(err?.message || "Beklenmedik bir hata oluştu.");
        }
    };

    return (
        <div className="container-fluid py-3 py-md-4">
            <div className="row justify-content-center">
                <div className="col-12 col-lg-9 col-xl-8">
                    <div className="card shadow-sm border-0">
                        <div className="card-body p-3 p-md-4">
                            <div className="text-center mb-4">
                                <h1 className="h3 mb-1">Kurumsal Paket Oluştur</h1>
                                {/* <p className="text-muted mb-0">{t("createPackage")}</p> */}
                            </div>

                            {msg ? <div className="alert alert-danger">{msg}</div> : null}

                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label htmlFor="packageName" className="form-label">
                                        {t("packageName")}
                                    </label>
                                    <textarea
                                        className="form-control"
                                        id="packageName"
                                        value={form.packageName}
                                        onChange={handleChange}
                                        required
                                        rows={2}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="packageDetail" className="form-label">
                                        {t("packageDescription")}
                                    </label>
                                    <textarea
                                        className="form-control"
                                        id="packageDetail"
                                        value={form.packageDetail}
                                        onChange={handleChange}
                                        required
                                        rows={3}
                                    />
                                </div>

                                <div className="row">
                                    <div className="col-12 col-md-6 mb-3">
                                        <label htmlFor="packagePrice" className="form-label">
                                            {t("packagePrice")}
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="packagePrice"
                                            value={form.packagePrice}
                                            onChange={handleChange}
                                            required
                                        />
                                        <small className="text-muted">{t("useNumbers")}</small>
                                    </div>

                                    <div className="col-12 col-md-6 mb-3">
                                        <label htmlFor="studentLimit" className="form-label">
                                            Toplam Öğrenci Sayısı
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="studentLimit"
                                            value={form.studentLimit}
                                            onChange={handleChange}
                                            required
                                        />
                                        <small className="text-muted">{t("useNumbers")}</small>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12 col-md-6 mb-3">
                                        <label htmlFor="howManyDays" className="form-label">
                                            {t("validityDate")}
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="howManyDays"
                                            value={form.howManyDays}
                                            onChange={handleChange}
                                            required
                                        />
                                        <small className="text-muted">
                                            {t("useNumbers")} {t("daily")}
                                        </small>
                                    </div>

                                    <div className="col-12 col-md-6 mb-3">
                                        <label htmlFor="sectionId" className="form-label">
                                            Kurs Seçiniz
                                        </label>
                                        <select
                                            id="sectionId"
                                            className="form-select"
                                            value={form.sectionId}
                                            onChange={handleChange}
                                            required
                                            disabled={loadingSections}
                                        >
                                            <option value="">
                                                {loadingSections ? "Sectionlar yükleniyor..." : t("select")}
                                            </option>
                                            {sections.map((section) => (
                                                <option key={section.id} value={section.id}>
                                                    {section.sectionName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div className="d-grid d-md-flex justify-content-md-center mt-4">
                                    <button type="submit" className="btn btn-primary btn-lg px-4">
                                        {t("create")}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminPackageCreateCorporate;